module.exports = __webpack_public_path__ + "static/media/Los_Angeles_Kings.7c71496b.svg";